import { QueryConfig } from "store/utils/query-config";

export const connectionListDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["metaData.createdTime"]
  }
};
